<template>
	<div class="dropdown">
		<input
			type="text"
			style="padding-right: 18px"
			@keydown.esc="setOpen(false)"
			@blur="setOpen(false)"
			@focus="setOpen(true)"
			ref="search"
			class="form-control input-sm"
			:disabled="disabled"
			@keydown.down="down"
			@keydown.up="up"
			@keydown.enter="suggestionSelected(_filtered[highlightIndex])"
			v-model="searchText"
			@input="searchChanged"
		/>

		<i
			aria-hidden="true"
			v-if="!disabled"
			@mousedown.prevent
			@click="setOpen(!open)"
			class="fa icone-lista"
			:class="{'fa-caret-up': !open, 'fa-caret-down': open}"
		></i>

		<!-- <input v-model="value" style="display: none"/> -->

		<div :class="{open: open}">
			<ul class="suggestion-list">
				<li
					v-for="(suggestion, index) in _filtered"
					:key="index"
					@mousedown.prevent
					:class="{active: index === highlightIndex}"
					@click="suggestionSelected(suggestion)"
				>
					{{ suggestion[label] }}
				</li>
			</ul>
		</div>
		<!-- <pre>{{ _filtered }}</pre> -->
	</div>
</template>

<script>
export default {
	props: {
		disabled: {
			default: false
		},

		value: {
			required: false
		},
		list: {
			type: Array,
			required: false,
			default: () => []
		},
		return: {
			required: false,
			default: null
		},
		label: '',

		placeholder: {
			type: String,
			default: 'Enter an item name to search'
		}
	},

	data() {
		return {
			searchText: this.value,
			open: false,
			selecionado: null,
			highlightIndex: 0
		}
	},

	watch: {
		value(val) {
			this.searchText = val
		}
	},

	computed: {
		_filtered() {
			var self = this
			return this.list.filter(function (cust) {
				return (
					cust[self.label]
						.toLowerCase()
						.indexOf(self.searchText.toLowerCase()) >= 0
				)
			})
		}
	},

	methods: {
		searchChanged() {
			if (!this.open) {
				this.open = true
			}
			this.highlightIndex = 0
		},

		setOpen(isOpen) {
			this.open = isOpen

			if (this.open) {
				this.$refs.search.focus()
			}

			if (!this.open) {
				var self = this
				var item = this.list.filter(function (cust) {
					if (cust[self.label] == self.searchText) {
						return (
							cust[self.label]
								.toLowerCase()
								.indexOf(self.searchText.toLowerCase()) >= 0
						)
					}
				})
				if (item.length == 1) {
					this.suggestionSelected(item[0])
				} else {
					this.searchText = ''
					this.$emit('v-model', this.return == '' ? '' : '')
				}
			}
		},

		suggestionSelected(suggestion) {
			this.open = false
			this.searchText = suggestion[this.label]
			this.$emit(
				'v-model',
				this.return == null ? suggestion[this.label] : suggestion[this.return]
			)
		},

		up() {
			if (this.open) {
				if (this.highlightIndex > 0) {
					this.highlightIndex--
				}
			} else {
				this.setOpen(true)
			}
		},

		down() {
			if (this.open) {
				if (this.highlightIndex < this._filtered.length - 1) {
					this.highlightIndex++
				}
			} else {
				this.setOpen(true)
			}
		}
	}
}
</script>

<style scoped>
.icone-lista {
	position: absolute;
	top: 6px;
	font-size: 12px;
	right: 6px;
	color: #777;
	z-index: 0;
	cursor: pointer;
}

.dropdown {
	position: relative;
}

.active {
	color: #fff !important;
	background-color: #1976d2 !important;
}

.suggestion-list {
	background-color: #fff !important;
	border: 1px solid #ddd;
	list-style: none;
	display: block;
	padding: 0;
	width: 100%;
	position: absolute;
	overflow-x: scroll;
	left: 0;
	margin: 0px;
	z-index: 3;
	max-height: 300px;
}

.suggestion-list li {
	cursor: pointer;
	padding: 4px;
	border-bottom: 1px solid #ddd;
}

.suggestion-list li:hover {
	color: #777;
	background-color: #eee;
}

.dropdown .open .suggestion-list {
	display: block;
}

.dropdown .suggestion-list {
	display: none;
}
</style>